module.exports = __webpack_public_path__ + "img/ico-5.72dab2c2.svg";